import React from 'react';
import { ReactComponent as CountDownSVG } from './countdown.svg';

export default function CountDownIcon({ width = 22, height = 22, color = '#E78700' }) {
  return (
    <CountDownSVG
      width={width}
      height={height}
      style={{ color: color }}
    />
  );
}
